import React from 'react';

import {
	ContactContainer,
	Card,
	LeftCard,
	RightCard,
	EachContact,
	IconContact,
	TextContact,
	TitleContact,
	Illustration,
	Map,
} from './styles';

import illustration from '../../assets/images/contact3.svg';
import location from '../../assets/icons/location-pin.svg';

const ContactUs = () => {
	return (
		<ContactContainer id={'contact'}>
			<Card>
				<LeftCard>
					<Map
						src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3283.4296286686845!2d-58.37762638480074!3d-34.618581780455706!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x95bccb2bb1001bed%3A0xd46c3569f43f4ea2!2sEstados%20Unidos%20686%2C%20C1101%20AAN%2C%20Buenos%20Aires!5e0!3m2!1ses!2sar!4v1614862065362!5m2!1ses!2sar'
						allowfullscreen=''
						loading='lazy'
					/>
				</LeftCard>
				<RightCard>
					<TitleContact>Contacto</TitleContact>

					<EachContact>
						<IconContact src={location} />
						<TextContact>Estados Unidos 686, C1101 CABA</TextContact>
					</EachContact>

					<EachContact>
						<IconContact src={location} />
						<TextContact> 011 - 5601 - 1120</TextContact>
					</EachContact>

					<EachContact>
						<IconContact src={location} />
						<TextContact>ortopediaevolucion@gmail.com</TextContact>
					</EachContact>

					<Illustration src={illustration} />
				</RightCard>
			</Card>
		</ContactContainer>
	);
};

export default ContactUs;
